import { Grid, FormControlLabel, Checkbox } from '@mui/material';
import { FC, SetStateAction, Dispatch } from 'react';
import { FiltersLayout, SearchField } from '../../../components';

interface IClientsFilters {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  setHasAppliedFilters: Dispatch<SetStateAction<boolean>>;
  hasAppliedFilters: boolean;
  setSearchValue?: (val: string) => void;
  setSearchedValue?: (val: string) => void;
  searchValue?: string;
  handleSearch?: (val: string) => void;
  searchPlaceholder?: string;
  isIncludeComplete: boolean;
  setIncludeComplete: (val: boolean) => void;
  isIncludeHiddenPurchasers: boolean;
  setIncludeHiddenPurchasers: (val: boolean) => void;
}

export const ClientsFilters: FC<IClientsFilters> = ({
  isLoading,
  applyFilters,
  setHasAppliedFilters,
  hasAppliedFilters,
  handleSearch,
  searchValue,
  setSearchValue,
  setSearchedValue,
  searchPlaceholder,
  setIncludeComplete,
  isIncludeComplete,
  isIncludeHiddenPurchasers,
  setIncludeHiddenPurchasers
}) => {
  return (
    <FiltersLayout>
      {handleSearch && (
        <Grid item xs={12} sm={6} md={4}>
          <SearchField
            isDisabled={isLoading}
            placeholder={searchPlaceholder}
            handleSearch={handleSearch}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={6} md={8}>
        <FormControlLabel
          color="primary"
          control={
            <Checkbox
              checked={isIncludeComplete}
              id="orders-checkbox"
              onChange={(_, checked) => setIncludeComplete(checked)}
            />
          }
          label="Include Complete"
        />
        <FormControlLabel
          color="primary"
          control={
            <Checkbox
              checked={isIncludeHiddenPurchasers}
              id="hidden-purchasers"
              onChange={(_, checked) => setIncludeHiddenPurchasers(checked)}
            />
          }
          label="Include Hidden Purchasers"
        />
      </Grid>
    </FiltersLayout>
  );
};
